import React, { useState } from "react";
import { CheckCircle2, Copy } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { CITIZEN } from "@/constants/testIds";

export default function RTIPage() {
  const [form, setForm] = useState({ applicant_name:"", address:"", subject:"", information_sought:"", email:"", phone:"" });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setError("");
    try {
      const { data } = await api.post("/rti", form);
      setResult(data);
    } catch (e) { setError(formatErr(e.response?.data?.detail) || e.message); }
  };

  if (result) {
    return (
      <div className="container-x py-16 max-w-xl">
        <div data-testid="rti-success" className="rounded-2xl border border-emerald-400/30 bg-emerald-500/5 p-8 text-center">
          <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-500"/>
          <h1 className="mt-4 text-3xl font-heading font-bold">RTI Application received</h1>
          <p className="mt-2 text-muted-foreground">You'll receive updates on your registered contact.</p>
          <div className="mt-6 rounded-xl bg-card border border-border p-4 flex items-center justify-between gap-3">
            <div>
              <div className="label-tiny text-muted-foreground">Tracking ID</div>
              <div className="font-mono font-semibold">{result.tracking_id}</div>
            </div>
            <button className="btn-outline" onClick={()=>navigator.clipboard.writeText(result.tracking_id)}><Copy className="h-4 w-4"/></button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-x py-12 max-w-3xl">
      <div className="label-tiny text-[hsl(var(--primary))]">Right to Information</div>
      <h1 className="mt-1 text-3xl font-heading font-bold">File an RTI application</h1>
      <p className="mt-2 text-muted-foreground">RTI Act 2005 · Public Information Officer, PEDA</p>
      <form onSubmit={submit} className="mt-8 rounded-2xl border border-border bg-card p-6 grid sm:grid-cols-2 gap-4">
        <F label="Full name"><input required className="input" value={form.applicant_name} onChange={change("applicant_name")}/></F>
        <F label="Phone"><input className="input" value={form.phone} onChange={change("phone")}/></F>
        <F label="Email"><input type="email" className="input" value={form.email} onChange={change("email")}/></F>
        <F label="Subject"><input required className="input" value={form.subject} onChange={change("subject")}/></F>
        <F label="Postal address" cols="2"><textarea required rows={2} className="input" value={form.address} onChange={change("address")}/></F>
        <F label="Information sought" cols="2"><textarea required rows={5} className="input" value={form.information_sought} onChange={change("information_sought")}/></F>
        {error && <div className="sm:col-span-2 text-red-500 text-sm">{error}</div>}
        <button data-testid={CITIZEN.rtiSubmit} className="btn-primary sm:col-span-2 justify-self-start" type="submit">Submit RTI</button>
      </form>
    </div>
  );
}

function F({ label, cols, children }) {
  return (
    <label className={`flex flex-col gap-1.5 ${cols === "2" ? "sm:col-span-2" : ""}`}>
      <span className="text-xs font-semibold text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}
